import { Injectable } from '@angular/core';

@Injectable()
export class PaymentMethodsStaticDataService {
  years: any[];

  constructor() {    
    this.years = [];
    let year = new Date().getFullYear();
    for(let i=0; i<15; i++) {
      this.years.push(year++);
    }
  }

  public months: object[] = [
    {
      'key': 1,
      'value': '01 - Enero'
    },
    {
      'key': 2,
      'value': '02 - Febrero'
    },
    {
      'key': 3,
      'value': '03 - Marzo'
    },
    {
      'key': 4,
      'value': '04 - Abril'
    },
    {
      'key': 5,
      'value': '05 - Mayo'
    },
    {
      'key': 6,
      'value': '06 - Junio'
    },
    {
      'key': 7,
      'value': '07 - Julio'
    },
    {
      'key': 8,
      'value': '08 - Agosto'
    },
    {
      'key': 9,
      'value': '09 - Septiembre'
    },
    {
      'key': 10,
      'value': '10 - Octubre'
    },
    {
      'key': 11,
      'value': '11 - Noviembre'
    },
    {
      'key': 12,
      'value': '12 - Diciembre'
    }
  ];

  public creditCardIcons: object[] = [{
      name: 'Visa',
      path: '../assets/Visa_Inc._logo.svg.png'
    },
    {
      name: 'MasterCard',
      path: '../assets/640px-MasterCard_logo.png'
    },
    {
      name: 'Discover',
      path: '../assets/Discover_Card-logo-4BC5D7C02C-seeklogo.com.png'
    },
    {
      name: 'AMEX',
      path: '../assets/2000px-American_Express_logo.svg.png'
    }
  ];
  
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/payment-methods-static-data.service.ts